import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./history.css";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function HistoryCasino() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    function formatDate(m) {
        var m = new Date(m);
        m.setHours(m.getHours() - 1);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    // HÀM DỊCH KẾT QUẢ CƯỢC (TÀI XỈU, XÓC ĐĨA...) THÀNH CHỮ
    const GetNameChoose = (state, type, gameName) => {
        if (state == null || state === undefined) return "";
        let stateStr = state.toString();

        if (gameName) {
            let nameLower = gameName.toLowerCase();
            
            // Xử lý Xóc đĩa
            if (nameLower.includes("xóc đĩa") || nameLower.includes("xoc dia")) {
                let res = [];
                stateStr.split(" ").forEach((item) => {
                    if (Number(item) === 1) res.push("4 đỏ");
                    if (Number(item) === 2) res.push("4 trắng");
                    if (Number(item) === 3) res.push("3 đỏ 1 trắng");
                    if (Number(item) === 4) res.push("3 trắng 1 đỏ");
                    if (Number(item) === 5) res.push("Chẵn");
                    if (Number(item) === 6) res.push("Lẻ");
                });
                return res.length > 0 ? res.join(", ") : stateStr;
            }
            // Xử lý Tài xỉu / Sicbo
            if (nameLower.includes("tài xỉu") || nameLower.includes("tai xiu") || nameLower.includes("sicbo")) {
                let res = [];
                stateStr.split(" ").forEach((item) => {
                    if (Number(item) === 1) res.push("Chẵn");
                    if (Number(item) === 2) res.push("Lẻ");
                    if (Number(item) === 3) res.push("Tài");
                    if (Number(item) === 4) res.push("Xỉu");
                });
                return res.length > 0 ? res.join(", ") : stateStr;
            }
        }
        return stateStr;
    };

    const [history, setHistory] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(new Date());

    useEffect(() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => function () {});
    }, []);

    const selectHistory = (date) => {
        if (isLoading == true) return;
        setLoading(true);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/historymember`, { date: formattedDate })
            .then((res) => {
                setHistory(res.data.data);
                setLoading(false);
            })
            .then((res) => {
                setLoading(false);
            });
    };

    const productId = (data) => {
        let a;
        switch (data.toString()) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "99": a = "TF"; break;
            case "111": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        return a;
    };

    return (
        <>
            {isLoading ? (
                <div className="loading" style={{ maxWidth: "100%" }}>
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="historyrecharge">
                <div className="top_title">
                    <div className="txt">Lịch sử sảnh game</div>
                </div>
                <center style={{ margin: "10px 0" }}>
                    <DatePicker
                        maxDate={new Date()}
                        selected={endDate}
                        onChange={(date) => {
                            setEndDate(date);
                            selectHistory(date);
                        }}
                    />
                </center>
                {history ? (
                    <div className="main-history">
                        {/* ĐÃ CHIA LẠI % CỘT ĐỂ CHÈN THÊM CỘT "LỰA CHỌN" VÀO */}
                        <div className="header-history">
                            <div style={{ width: "10%" }}>Sảnh</div>
                            <div style={{ width: "10%" }}>Loại</div>
                            <div style={{ width: "15%" }}>Tên trò chơi</div>
                            <div style={{ width: "15%" }}>Lựa chọn</div>
                            <div style={{ width: "10%" }}>Điểm cược</div>
                            <div style={{ width: "10%" }}>Điểm thắng</div>
                            <div style={{ width: "15%" }}>Mã giao dịch</div>
                            <div style={{ width: "15%" }}>Thời gian</div>
                        </div>
                        {history?.map((item, key) => (
                            <div className="content-history" key={key}>
                                <div style={{ width: "10%" }}>{productId(item?.productType)}</div>
                                <div style={{ width: "10%" }}>{item?.gameCategory}</div>
                                <div style={{ width: "15%" }}>{item?.gameName}</div>
                                
                                {/* CỘT LỰA CHỌN MỚI THÊM - HIỂN THỊ CHẴN, LẺ, TÀI, XỈU... */}
                                <div style={{ width: "15%", color: "red" }}>
                                    {GetNameChoose(item?.state, null, item?.gameName)}
                                </div>
                                
                                <div style={{ width: "10%" }}>{Math.floor((item?.betAmount || 0) / 1000).toLocaleString("vi-VN")}</div>
                                <div style={{ width: "10%" }}>{Math.floor((item?.winAmount || 0) / 1000).toLocaleString("vi-VN")}</div>
                                <div style={{ width: "15%", wordBreak: "break-word" }}>{item?.betOrderNo}</div>
                                <div style={{ width: "15%" }}>{formatDate(new Date(item?.betTime))}</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        </>
    );
}

export default HistoryCasino;